import marketApi from './marketApi';

/**
 * Paiement Mobile Money PAY-FIRST (SerdiPay via proxy backend) — helper partagé
 * par toutes les verticales web (livraison, billets, beauté…).
 * Initie puis attend la confirmation (~2 min max). Résout avec payment_id, ou
 * rejette avec un message clair. `onPhase(texte)` permet d'afficher l'attente.
 */
export async function mmPay({ userId, amount, phone, telecom = 'AM', label, planType = 'purchase', onPhase }) {
  const num = String(phone || '').replace(/\D/g, '');
  if (num.length < 9) throw new Error('Numéro Mobile Money invalide (ex. 0991234567).');
  const intl = num.startsWith('243') ? num : `243${num.replace(/^0/, '')}`;

  onPhase && onPhase('Envoi de la demande de paiement…');
  const init = await marketApi.mmInitiate({
    user_id: userId,
    plan_type: planType,
    plan_name: label,
    amount, currency: 'CDF', payment_currency: 'CDF',
    phone_number: intl, telecom,
  });
  if (!init?.success || !init.payment_id) throw new Error(init?.error || 'Initiation du paiement impossible');

  onPhase && onPhase('Confirmez le paiement sur votre téléphone…');
  for (let i = 0; i < 40; i++) {
    await new Promise(r => setTimeout(r, 3000));
    const st = await marketApi.mmStatus(init.payment_id).catch(() => null);
    const status = st?.payment?.status;
    if (status === 'completed') return { paymentId: init.payment_id, intl };
    if (status === 'failed') throw new Error(st?.payment?.error_message || 'Paiement refusé.');
  }
  throw new Error('Paiement non confirmé dans le délai. Aucun montant ne sera prélevé sans confirmation.');
}

export default mmPay;
